import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello there, I am <span className="purple">Mirko</span> from{" "}
            <span className="purple">near Milan, Italy.</span>
            <br />
            I am a developer with a passion for creating innovative solutions,
            specializing in bots and gaming communities.
            <br />
            <br />
            Here are three dynamic projects I take pride in:
          </p>
          <ul>
          <li className="about-activity">
              <ImPointRight /> <b>FiveM</b>: Providing in-game support across two French servers, ensuring a smooth and enjoyable gaming journey.
            </li>
            <li className="about-activity">
              <ImPointRight /> <b>Fortnite Italia</b>: Assisting the Fortnite community by resolving technical challenges and enriching players' gaming experiences.
            </li>
            <li className="about-activity">
              <ImPointRight /> <b>Local Hub Bot</b>: Created by me, this bot is designed to streamline business management for RP servers. It automates tasks like tracking invoices, calculating earnings, managing work hours, and providing detailed reports to improve efficiency and accuracy in server operations.
          </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Innovation thrives on passion, and progress is powered by collaboration."{" "}
          </p>
          <footer className="blockquote-footer">Mirko</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
